import { Box, Stack, Typography } from 'ui';
import { Mood } from 'ui/icons';

export const StepFive = () => {
  return (
    <Stack alignItems="center" gap={2}>
      <Box display="flex" alignItems="center" gap={1}>
        <Typography fontWeight="bold">Complete Analysis</Typography>
        <Mood />
      </Box>

      <Typography textAlign="center">
        When you have taken all of your photos, tap ‘<strong>Complete</strong>’ to review them.
      </Typography>
    </Stack>
  );
};
